var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancellations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.531,
    height: 14.531,
    viewBox: "0 0 14.531 14.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-5.156-10.752A7.027,7.027,0,0,1,0-12.891a7,7,0,0,1,5.142,2.124A7,7,0,0,1,7.266-5.625,7,7,0,0,1,5.142-.483,7,7,0,0,1,0,1.641,7,7,0,0,1-5.142-.483,7,7,0,0,1-7.266-5.625,6.979,6.979,0,0,1-5.156-10.752ZM-6.328-5.42a6.136,6.136,0,0,0,1.86,4.263A6.136,6.136,0,0,0-.205.7,6.04,6.04,0,0,0,4.131-.82L-4.8-9.756A6.04,6.04,0,0,0-6.328-5.42ZM4.8-1.494A6.04,6.04,0,0,0,6.328-5.83a6.136,6.136,0,0,0-1.86-4.263,6.136,6.136,0,0,0-4.263-1.86A6.04,6.04,0,0,0-4.131-10.43Z",
    transform: "translate(7.266 12.891)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellations);
export default __webpack_public_path__ + "static/media/cancellations.634b4089c1303a0b355b17cbb6ca05df.svg";
export { ForwardRef as ReactComponent };